// ganttConstants.js - Centralized constants for Gantt Chart
export const TASK_HEIGHT = 28;
export const TASK_SPACING = 8;
export const CATEGORY_PADDING = 8;
export const ROW_NAME_WIDTH = 200;

// Scroll and expansion settings
export const EXPANSION_THRESHOLD = 0.9;
export const EXPANSION_AMOUNT = 50;

// Timeline settings
export const BUFFER_DAYS = 30;

// View mode settings
export const VIEW_MODES = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};

export const DAY_WIDTHS = {
  [VIEW_MODES.DAY]: 300,
  [VIEW_MODES.WEEK]: 80,
  [VIEW_MODES.MONTH]: 40,
};

// Default timeline range (in days relative to base date)
export const DEFAULT_TIMELINE_START = -30;
export const DEFAULT_TIMELINE_END = 90;

// Ghost task settings
export const DEFAULT_MAX_GHOST_INSTANCES = 50;
